import { useState } from 'react';
import {
  CopilotImportStrategy,
  OrganizationSelectionType
} from '../CopilotSetting.types';

interface CopilotImportStrategyFormProps {
  settingValue: CopilotImportStrategy;
}

export interface CopilotImportStrategyFormState {
  selectionMethod: OrganizationSelectionType;
  setSelectionMethod: (selectionMethod: OrganizationSelectionType) => void;
  regexPattern: string;
  setRegexPattern: (regexPattern: string) => void;
  selectedOrgs?: string[];
  setSelectedOrgs: (selectedOrgs: string[]) => void;
}

const useCopilotImportStrategyForm = ({
  settingValue
}: CopilotImportStrategyFormProps): CopilotImportStrategyFormState => {
  const [selectionMethod, setSelectionMethod] = useState<string>(
    settingValue?.selection_type
  );
  const [regexPattern, setRegexPattern] = useState<string>(
    settingValue?.regex || ''
  );
  const [selectedOrgs, setSelectedOrgs] = useState<string[]>(
    settingValue?.organizations || []
  );

  return {
    selectionMethod,
    setSelectionMethod,
    regexPattern,
    setRegexPattern,
    selectedOrgs,
    setSelectedOrgs
  };
};

export default useCopilotImportStrategyForm;
